var $5Vw6t$styledcomponents = require("styled-components");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Box", {
    enumerable: true,
    get: function get() {
        return $11940384c25e2dec$exports.Box;
    }
});
var $11940384c25e2dec$exports = {};
"use strict";
Object.defineProperty($11940384c25e2dec$exports, "__esModule", {
    value: true
});
$11940384c25e2dec$exports.Box = void 0;

var $11940384c25e2dec$var$_styledComponents = $11940384c25e2dec$var$_interopRequireDefault($5Vw6t$styledcomponents);
var $11940384c25e2dec$var$_templateObject;
function $11940384c25e2dec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $11940384c25e2dec$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $11940384c25e2dec$var$Box = $11940384c25e2dec$exports.Box = $11940384c25e2dec$var$_styledComponents["default"].div($11940384c25e2dec$var$_templateObject || ($11940384c25e2dec$var$_templateObject = $11940384c25e2dec$var$_taggedTemplateLiteral([
    "\n  background-color: ",
    ";\n  padding: 15px;\n  ",
    ";\n  border-radius: 4px;\n\n  &:hover {\n    ",
    ";\n  }\n"
])), function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.boxShadow.level1;
}, function(props) {
    return props.theme.boxShadow.level2;
});




//# sourceMappingURL=index.js.map
